import { Mobile, Scrollbar, Navigation, TRANSITION_END } from '../core'
import '../plugins/share-toolbar'

$.fn.PanelOverlay = function(panels, panel) {
  let self = this

  if (self.data('panel-overlay')) {
    return self.data('panel-overlay')
  }

  self.el = {
    close: undefined,
    back: undefined,
    toolbar: undefined,
    scroller: undefined,
  }
  self.scroller = undefined

  self.close = function(e) {
    if ($(this).data('target-panel')) {
      // do nothing
    } else {
      if (e != undefined && !$(this).data('target-panel')) {
        e.preventDefault()
      }
      if (self.el.scroller != undefined) {
        self.el.scroller.off('mousewheel', self.mousewheeled)
      }
      panels.el.footer.off('mousewheel', self.mousewheeled)
      panels.dismiss_footer()
      if (panels.el.extra != undefined) {
        if (!$.mlmi.mobile.matchesMedia()) {
          panels.el.extra.attr('style', '').addClass('extra--leaving').on(TRANSITION_END, function() {
            panels.el.extra.off(TRANSITION_END)
            panels.el.extra.remove()
          })
        }
      }
      if (panel.hasModifier('status-closed')) {
        self.closed()
      } else {
        self.on(TRANSITION_END, self.closed).removeModifier('visible')
      }
    }
  }

  self.closed = function(e) {
    if (e == undefined || $(e.target).hasClass('panel__overlay')) {
      self.off(TRANSITION_END)
    }
    panel.trigger('overlay_closed')
    self.remove()
  }

  self.initialize_overlay = function(overlayCard) {
    /* Initialize content */
    self.find('.panel__overlay__card').replaceWith(overlayCard)

    /* Scroller */
    self.scroller = new Scrollbar(self.get(0))
    self.el.toolbar = self.find('.overlay-toolbar')
    if (self.el.toolbar.length) {
      self.el.toolbar.ShareToolbar(self)
    }
    self.el.scroller = self.scroller.scrollers[0]

    /* Close button */
    self.el.close = self.find('.overlay-toolbar__close-btn')
    self.el.close.on('click', function(e) {
      self.close(e)
      if ('history' in window) {
        let popState = {
          ama: true,
          isPageTransition: false,
          previousPageURL: window.location.href,
          stepIncrement: panels.navigation.getStepIncrement(),
          panel: panel.name,
          overlay: false,
        }
        panels.st.last_state = Object.assign({}, panels.st.current_state)
        panels.st.current_state = Object.assign({}, popState)
        popState.previousState = Object.assign({}, panels.st.last_state)
        document.title = panel.attr('data-title')
        window.history.pushState(popState, document.title, panel.data('url'))
      }
    }).data('preventTransition', 1)

    /* Back button */
    self.el.back = self.find('.single-article__back-btn')
    if (self.el.back.length) {
      let currentState = undefined
      if ('history' in window) {
        currentState = window.history.state
        self.el.back.on('click', function() {
          window.history.back()
        })
      }
      if (currentState == undefined || currentState.previousState == undefined || !currentState.previousState.overlay) {
        self.el.back.remove()
      } else if (!$.mlmi.mobile.matchesMedia()) {
        if (currentState.previousState.panel == 'panorama' && currentState.previousState.previousTitle != undefined) {
          self.el.back.find('.label').html(ateliermonarque_l10n.BACK_TO + ' ' + currentState.previousState.previousTitle)
          if (!self.find('.single-article__title--glossaire').length) {
            self.el.back.remove()
          }
        } else if (currentState.previousState.panel == 'portfolio' && panels.st.current_panel.name != 'portfolio') {
          self.el.back.find('.label').html(ateliermonarque_l10n.BACK_TO_PROJECT)
        }
      }
    }
    if (panels.st.current_state != undefined) {
      panels.st.current_state.previousTitle = self.find('.single-article__title--glossaire').length ? self.find('.single-article__title--glossaire').html() : ''
    }

    /* Inside overlay */
    self.find('.project-details').each(function() {
      $(this).ProjectDetails(self)
    })
    self.find('.gallery').each(function() {
      $(this).Gallery()
    })
    $('.extra .card-panorama__image').each(function() {
      $(this).DuotoneHover()
    })
    $('.extra .card-panorama, .extra .card-portfolio').each(function() {
      $(this).PositionHover()
    })

    /* Mousewheel scrollers */
    requestAnimationFrame(function() {
      if (!$.mlmi.isTouch) {
        self.el.scroller.off('mousewheel').on('mousewheel', self.mousewheeled)
        panels.el.footer.off('mousewheel').on('mousewheel', self.mousewheeled)
      }
    })
  }

  self.mousewheeled = function(e, delta) {
    if ($.mlmi.isTouch) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
    if (e.deltaY !== 0) {
      panels.st.last_scroller = self.el.scroller.el.scroller
      let scrollableHeight = panels.st.last_scroller.get(0).scrollHeight - panels.st.last_scroller.outerHeight(false),
      scrollPercentage = panels.st.last_scroller.scrollTop() / scrollableHeight
      if (scrollableHeight <= 1 || delta >= 0 || scrollPercentage >= 1) {
        let delta_factor = panel.total_scroll / panel.total_tick
        if (delta_factor > 60) {
          delta_factor = 60
        } else if (delta_factor < 1) {
          delta_factor = 1
        }
        panels.move_footer(e, delta * delta_factor, panels.st.last_scroller)
      } else if (e.deltaY < 0) {
        panel.total_tick -= e.deltaY
        if (panels.st.last_scroller.scrollTop() > panel.last_scroll) {
          panel.total_scroll += (panels.st.last_scroller.scrollTop() - panel.last_scroll)
        }
        panel.last_scroll = panels.st.last_scroller.scrollTop()
      } else {
        panel.last_scroll = panels.st.last_scroller.scrollTop()
      }
    }
  }

  self.after_intro = function() {
    setTimeout(function() {
      self.addModifier('visible')
    }, 250)
  }

  return function() {
    self.BlockElement()
    if (self.find('.overlay-toolbar').length) {
      self.initialize_overlay(self.find('.panel__overlay__card'))
    }
    $('body').on('intro_played', self.after_intro)
    self.data('panel-overlay', self)
    return self
  }()
}

$.fn.Panel = function(panels) {
  let self = this

  if (self.data('panel')) {
    return self.data('panel')
  }

  self.name = self.data('name')
  self.el = {
    content: self.find('.panel__content'),
    overlay: self.find('.panel__overlay'),
    card: self.find('.panel__card'),
    scroller: undefined,
  }
  self.scroller = undefined
  self.last_scroll = 0
  self.third_scroll = 0
  self.overlay = undefined
  self.previous_overlay = undefined

  self.is_expanded = function() {
    return self.attr('aria-expanded') === 'true'
  }

  self.create_overlay = function() {
    if ($.mlmi.mobile.matchesMedia()) {
      self.maximize()
    }
    if (self.overlay == undefined) {
      let overlay = $('<div>').addClass('panel__overlay').BlockElement().addModifier('loading'),
      overlayCard = $('<div>').addClass('panel__overlay__card').BlockElement()
      overlay.append(overlayCard)
      self.overlay = overlay.PanelOverlay(panels, self)
      self.el.content.after(self.overlay)
      requestAnimationFrame(function() {
        self.overlay.addModifier('visible')
      })
    }
  }

  self.remove_overlay = function() {
    if ($.mlmi.mobile.matchesMedia()) {
      self.maximize()
    }
    if (panels.st.is_between_overlays) {
      panels.st.is_between_overlays = false
    } else {
      if (panels.el.extra != undefined) {
        panels.el.extra.find('.extra__content').off('mousewheel')
        panels.el.extra.remove()
        panels.el.extra = undefined
      }
      if (self.overlay != undefined) {
        self.overlay.off('mousewheel')
        self.overlay.removeModifier('visible')
        self.overlay.remove()
        self.overlay = undefined
      }
      if (self.previous_overlay != undefined) {
        self.previous_overlay.off('mousewheel')
        self.previous_overlay.removeModifier('visible')
        self.previous_overlay.remove()
        self.previous_overlay = undefined
      }
    }
  }

  self.set_extra = function() {
    if (panels.el.extra != undefined && $.mlmi.mobile != undefined) {
      if ($.mlmi.isTouch) {
        if ($.mlmi.mobile.matchesMedia()) {
          if (self.overlay.find('.panel__overlay__card .project').length) {
            self.overlay.find('.panel__overlay__card .project').after(panels.el.extra)
          } else {
            self.overlay.find('.panel__overlay__card .single-article').after(panels.el.extra)
          }
        } else {
          self.overlay.find('.panel__overlay__card .article__content').append(panels.el.extra)
        }
      } else {
        panels.el.footer.before(panels.el.extra)
        requestAnimationFrame(function() {
          panels.el.extra.find('.extra__content').off('mousewheel').on('mousewheel', self.overlay.mousewheeled)
        })
      }
    }
  }

  self.set_content = function(loaded_content) {
    let overlayCard = loaded_content.find('.panel__overlay__card')
    if (panels.el.extra != undefined) {
      panels.el.extra.find('.extra__content').off('mousewheel')
      panels.el.extra.remove()
      panels.el.extra = undefined
    }
    if (loaded_content.find('.extra').length) {
      panels.el.extra = loaded_content.find('.extra')
    }
    self.overlay.initialize_overlay(overlayCard)
    panels.st.covered_scrolled = false
    requestAnimationFrame(function() {
      self.overlay.removeModifier('loading')
      self.set_extra()
    })
  }

  self.maximize = function() {
    if (!panels.st.is_maximized) {
      if (self.name == 'panorama' || self.name == 'atelier') {
        panels.panels.portfolio.hide()
      }
      if (self.name == 'atelier') {
        panels.panels.panorama.hide()
      }
    }
    panels.removeModifier('minimized minimized-portfolio minimized-panorama minimized-atelier').addModifier('maximized maximized-' + self.name)
    if (!panels.st.is_maximized) {
      if (self.name == 'panorama' || self.name == 'atelier') {
        requestAnimationFrame(function() {
          panels.panels.portfolio.show()
        })
      }
      if (self.name == 'atelier') {
        requestAnimationFrame(function() {
          panels.panels.panorama.show()
        })
      }
    }
    panels.st.is_maximized = true
  }

  self.scrolled = function(e) {
    if ($.mlmi.isTouch) {
      if (!panels.st.is_transitioning && !panels.hasModifier('third')) {
        let scroller = self.el.scroller.el.scroller,
        minScrollLimit = parseInt(self.find('.panel__content-card').css('margin-top'), 10),
        contentScrollLimit = self.find('.panel__content-card').outerHeight(true) - self.height() - panels.el.footer.height(),
        new_scroll = self.el.scroller.el.scroller.scrollTop(),
        top = scroller.scrollTop(),
        direction = new_scroll < self.last_scroll ? 'up' : 'down',
        scroll_delta = new_scroll - self.last_scroll
        self.last_scroll = new_scroll

        /* mobile */
        if ($.mlmi.mobile.matchesMedia()) {
          /* mobile back to home */
          if (top < -40 && !panels.st.is_maximized) {
            scroller.css({
              'overflow': 'hidden',
              'margin-top': -top + 'px',
            })
            panels.back_to_home()
            if ($.mlmi.mobile.matchesMedia()) {
              requestAnimationFrame(function() {
                scroller.animate({
                  'margin-top': 0,
                }, 50, 'swing')
              })
            }
            setTimeout(function() {
              scroller.css('overflow', '')
            }, 1250)
          }

          /* mobile show tabs */
          if (panels.st.is_maximized && ((direction == 'up' && top < contentScrollLimit) || top <= 0)) {
            panels.addModifier('minimized minimized-' + self.name)
          } else if (!panels.st.is_maximized && top >= minScrollLimit) {
            self.maximize()
          } else if (direction == 'down') {
            panels.removeModifier('minimized minimized-portfolio minimized-panorama minimized-atelier')
          }
        }

        /* fix content */
        if (!self.hasClass('panels--transitioning')) {
          if (!panels.st.covered_scrolled && top >= contentScrollLimit) {
            let $sections = self.find('.panel__sections'),
            $card = self.find('.panel__content-card'),
            rect = $sections.get(0).getBoundingClientRect(),
            offset_x = rect.left,
            offset_y = (parseFloat(self.css('bottom')) * -1) + (parseFloat(self.css('top')) * -1)
            if (self.name == 'portfolio') {
              offset_y -= (parseFloat(self.css('top')) * -2)
              offset_x += (parseFloat(self.css('left')) * -1)
            }
            let properties = {
              'width': $sections.outerWidth(false),
              'height': $sections.outerHeight(false),
              'position': $.mlmi.mobile.matchesMedia() ? 'fixed' : 'absolute',
              'bottom': $.mlmi.mobile.matchesMedia() ? 0 : offset_y + 'px',
              'left': $.mlmi.mobile.matchesMedia() ? 0 : offset_x + 'px',
              'pointer-events': 'none',
              'z-index': $.mlmi.mobile.matchesMedia() ? 2 : 3,
            }
            panels.st.covered_scrolled = scroller.scrollTop()
            $card.css({
              'width': $card.outerWidth(false),
              'height': $card.outerHeight(false),
            })
            $sections.css(properties)
            if (!$.mlmi.mobile.matchesMedia()) {
              $sections.appendTo(self.find('.panel__content'))
            }
          } else if (panels.st.covered_scrolled && top < contentScrollLimit) {
            let $sections = self.find('.panel__sections'),
            $card = self.find('.panel__content-card')
            $sections.attr('style', '')
            if (!$.mlmi.mobile.matchesMedia()) {
              $sections.appendTo(self.find('.panel__sections-container'))
            }
            $card.css({
              'width': '',
              'height': '',
            })
            panels.st.covered_scrolled = false
          }
        }
      }
    }
  }

  self.last_tick = 1
  self.total_tick = 1
  self.last_scroll = 1
  self.total_scroll = 1

  self.mousewheeled = function(e, delta) {
    if ($.mlmi.isTouch) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
    panels.st.last_scroller = self.el.scroller.el.scroller
    if (self.overlay == undefined && e.deltaY !== 0) {
      let scrollableHeight = panels.st.last_scroller.get(0).scrollHeight - panels.st.last_scroller.outerHeight(false),
      scrollPercentage = panels.st.last_scroller.scrollTop() / scrollableHeight
      if (scrollableHeight <= 1 || (delta >= 0 || scrollPercentage >= .999)) {
        let delta_factor = self.total_scroll / self.total_tick
        if (delta_factor > 60) {
          delta_factor = 60
        } else if (delta_factor < 1) {
          delta_factor = 1
        }
        panels.move_footer(e, delta * delta_factor, panels.st.last_scroller)
      } else if (e.deltaY < 0) {
        self.total_tick -= e.deltaY
        if (panels.st.last_scroller.scrollTop() > self.last_scroll) {
          self.total_scroll += (panels.st.last_scroller.scrollTop() - self.last_scroll)
        }
        self.last_scroll = panels.st.last_scroller.scrollTop()
      } else {
        self.last_scroll = panels.st.last_scroller.scrollTop()
      }
    }
  }

  self.reset = function() {
    self.attr('aria-expanded', 'false')
    if (self.find('.grid--style--team').length) {
      self.find('.grid--style--team').ScrollEffect().reset_columns()
    }
    self.el.scroller.el.scroller.scrollTo(0, 350, 5, 'easeInOutQuart')
  }

  self.init = function() {
    self.on('click', function(e) {
      if ($(e.target).hasClass('panel__logo') || $(e.target).hasClass('panel__lang-switcher') || $(e.target).hasClass('btn-primary')) {
        // do not
      } else if (!self.is_expanded()) {
        let openDelay = 0,
        targetPanelName = self.name,
        targetPanel = panels.panels[targetPanelName]
        if (panels.st.covered_scrolled) {
          panels.dismiss_footer()
          openDelay = 225
        }
        setTimeout(function() {
          panels.move_footer('reset', 8000, undefined)
          setTimeout(function() {
            panels.open(targetPanelName, true)
          }, openDelay)
        }, openDelay)
      }
    })
    self.scroller = new Scrollbar(self.el.content.get(0))
    if (self.el.overlay.length) {
      self.overlay = self.el.overlay.PanelOverlay(panels, self)
      if (self.overlay.find('.extra').length) {
        panels.el.extra = self.overlay.find('.extra')
        self.set_extra()
      }
    }
    self.el.scroller = self.scroller.scrollers[0]
    self.last_scroll = self.el.scroller.el.scroller.scrollTop()
    self.el.scroller.el.scroller.on('scroll', self.scrolled)
    self.el.scroller.off('mousewheel').on('mousewheel', self.mousewheeled)
    self.on('overlay_closed', self.remove_overlay)
  }

  self.hovered_in = function() {
    if (!panels.hasClass('panels--covered')) {
      panels.addClass('panels--hover-' + self.name)
    } else {
      panels.st.last_hovered = self
    }
  }

  self.hovered_out = function() {
    if (!panels.hasClass('panels--covered')) {
      panels.removeClass('panels--hover-' + self.name)
    }
  }

  return function() {
    self.BlockElement().init()
    self.hover(self.hovered_in, self.hovered_out)
    self.data('panel', self)
    return self
  }()
}

$.fn.Panels = function() {
	let self = this

  if (self.data('panels')) {
    return self.data('panels')
  }

  self.panels = {}
  self.navigation = undefined
  self.content = undefined

  self.el = {
    panels: self.find('.panel'),
    content_cards: self.find('.panel__content-card'),
    footer: $('.footer').BlockElement(),
    extra: undefined,
  }
  self.st = {
    current_panel: undefined,
    is_transitioning: false,
    is_between_overlays: false,
    is_maximized: false,
    footer_transform: 0,
    covered_scroll: false,
    last_scroller: undefined,
    last_hovered: undefined,
    last_state: undefined,
    current_state: undefined,
    is_popping: false,
  }

  self.transition_start = function() {
    if (!self.st.is_transitioning) {
      self.st.is_transitioning = true
      self.panels.atelier.on(TRANSITION_END, self.transition_end)
      self.addModifier('transitioning')
      self.trigger('transition_started')
    }
  }

  self.transition_end = function(e) {
    if ($(e.target).hasClass('panel--atelier')) {
      self.panels.atelier.off(TRANSITION_END, self.transition_end)
      self.st.is_transitioning = false
      self.removeModifier('transitioning')
      self.trigger('transition_ended')
      for (let panelName in self.panels) {
        let panel = self.panels[panelName]
        panel.removeModifier('status-third status-closed status-opened')
        if (self.st.current_panel == undefined) {
          panel.addModifier('status-third')
        } else if (panel.is_expanded()) {
          panel.addModifier('status-opened')
        } else {
          panel.addModifier('status-closed')
          if (panel.overlay != undefined) {
            panel.previous_overlay = self.st.current_panel.overlay
            panel.overlay.close()
            panel.overlay = undefined
          }
        }
        panel.scroller.update()
        if (!$.mlmi.mobile.matchesMedia()) {
          panel.scroller.scrollers.forEach(function(scroller) {
            scroller.el.scroller.scrollTop(0)
          })
        }
      }
    }
  }

  self.reset = function(e) {
    if (e != undefined) {
      e.preventDefault()
    }
    if (self.st.current_panel != undefined) {
      self.st.current_panel.remove_overlay()
      self.st.current_panel = undefined
      self.transition_start()
      self.el.footer.css('transform', '')
      if (self.el.extra != undefined) {
        self.el.extra.css('transform', '')
      }
      self.removeModifier('covered').addModifier('third')
      self.removeModifier('minimized minimized-panorama minimized-portfolio minimized-atelier')
      self.removeModifier('maximized maximized-panorama maximized-portfolio maximized-atelier')
    }
    for (let panelName in self.panels) {
      let panel = self.panels[panelName]
      self.removeModifier('tab-' + panelName)
      panel.reset()
    }
    return self
  }

  self.open = function(panelName, pushState, hash) {
    let panel = self.panels[panelName]
    if (panel != undefined) {
      if (pushState) {
        self.navigation.abortRequest()
        if (!self.st.is_popping && 'history' in window) {
          let popState = {
            ama: true,
            isPageTransition: false,
            previousPageURL: window.location.href,
            stepIncrement: self.navigation.getStepIncrement(),
            panel: panelName,
            overlay: false,
          }
          self.st.last_state = Object.assign({}, self.st.current_state)
          popState.previousState = Object.assign({}, self.st.last_state)
          self.st.current_state = Object.assign({}, popState)
          document.title = panel.attr('data-title')
          window.history.pushState(popState, document.title, panel.data('url'))
        }
        self.st.is_popping = false
      }
      if (self.st.current_panel != panel) {
        let openDelay = 0
        if (self.st.current_panel != undefined && self.st.current_panel.overlay != undefined) {
          self.st.current_panel.previous_overlay = self.st.current_panel.overlay
          self.st.current_panel.overlay.close()
          self.st.current_panel.overlay = undefined
          openDelay = 250
        }
        setTimeout(function() {
          self.reset().removeModifier('third').addModifier('tab-' + panelName)
          panel.attr('aria-expanded', 'true')
          self.st.current_panel = panel
          self.transition_start()
          self.el.footer.css('transform', '')
          if (self.el.extra != undefined) {
            self.el.extra.css('transform', '')
          }
          self.removeModifier('covered')
        }, openDelay)
      }
      if (panelName != 'atelier' && $.mlmi.mobile.matchesMedia()) {
        $('.atelier-toolbar__menu').slideUp('fast')
      }
      // if (hash != undefined) {
      //   if (self.st.current_panel != undefined) {
      //     if (self.st.current_panel.overlay != undefined) {
      //       self.st.current_panel.overlay.close()
      //     }
      //   }
      // }
      self.set_footer(panel)
    }
    return self
  }

  self.maximize = function(e) {
    if (self.hasModifier('minimized')) {
      let oldTabName = self.st.current_panel.name,
      newTabName = $(this).data('tab'),
      panel = self.panels[newTabName]
      self.transition_start()
      self.removeModifier('minimized minimized-panorama minimized-portfolio minimized-atelier')
      self.removeModifier('maximized maximized-panorama maximized-portfolio maximized-atelier')
      self.removeModifier('tab-' + oldTabName)
      self.addModifier('maximized maximized-' + newTabName)
      self.addModifier('tab-' + newTabName)
      self.find('.scroller').scrollTop(0)
      self.panels.portfolio.attr('aria-expanded', 'false').removeModifier('status-opened').addModifier('status-closed')
      self.panels.panorama.attr('aria-expanded', 'false').removeModifier('status-opened').addModifier('status-closed')
      self.panels.atelier.attr('aria-expanded', 'false').removeModifier('status-opened').addModifier('status-closed')
      panel.attr('aria-expanded', 'true').removeModifier('status-closed').addModifier('status-opened')
      self.st.current_panel = panel
      self.set_footer(panel)
    } else {
      let openDelay = 0,
      targetPanelName = $(this).data('tab'),
      targetPanel = self.panels[targetPanelName],
      has_overlay = self.st.current_panel != undefined && self.st.current_panel.overlay != undefined
      if (has_overlay) {
        self.st.current_panel.overlay.close()
        self.dismiss_footer()
        openDelay = 225
      } else if (self.st.covered_scrolled) {
        self.dismiss_footer()
        openDelay = 225
      }
      setTimeout(function() {
        self.move_footer('reset', 8000, undefined)
        setTimeout(function() {
          if (self.st.covered_scrolled && !has_overlay) {
            targetPanel.el.scroller.el.scroller.scrollTop(0)
          }
          self.open(targetPanelName, true)
        }, openDelay)
      }, openDelay)
    }
  }

  self.link_clicked = function(link) {
    self.content = undefined
    let targetPanelName = link.data('target-panel'),
    targetPanel = self.panels[targetPanelName]
    if ($.mlmi.mobile.matchesMedia() && self.st.current_panel == targetPanel) {
      if (self.st.is_maximized) {
        self.removeModifier('minimized minimized-portfolio minimized-panorama minimized-atelier')
      } else {
        targetPanel.maximize()
      }
    }

    if (link.hasClass('card-panorama') || link.hasClass('card-lists') || link.hasClass('card-portfolio') || link.hasClass('card-jobs') || link.hasClass('card-jobs__cta')) {
      if (self.st.covered_scrolled) {
        self.dismiss_footer()
        setTimeout(function() {
          self.move_footer('reset', 8000, undefined)
        }, 250)
      }
    }

    if (self.st.current_panel != targetPanel) {
      if (link.data('overlay')) {
        self.on('transition_ended', self.display_content)
        self.open(targetPanelName, false)
      } else {
        self.open(targetPanelName, false)
        return -2
      }
    } else if (self.st.current_panel.overlay != undefined) {
      self.st.is_between_overlays = true
      if (self.st.current_panel.overlay != undefined) {
        self.st.current_panel.previous_overlay = self.st.current_panel.overlay
        self.st.current_panel.overlay.close()
        self.st.current_panel.overlay = undefined
      }
      self.dismiss_footer()
      targetPanel.create_overlay()
    } else {
      targetPanel.create_overlay()
    }
  }

  self.page_loaded = function(event, loaded_content) {
    self.content = $('<html>').html(loaded_content)
    self.display_content()
    self.st.is_popping = false
  }

  self.display_content = function(e) {
    if (e != undefined) {
      self.off('transition_ended', self.display_content)
    }
    if (self.st.current_panel != undefined) {
      self.st.current_panel.create_overlay()
      if (!self.st.is_transitioning && self.content != undefined) {
        self.st.current_panel.set_content(self.content)
      }
    }
  }

  self.move_footer = function(e, delta, scroller) {
    self.st.footer_transform += delta
    let footerHeight = self.el.footer.outerHeight(false),
    shadowDistance = 20,
    extraHeight = 0,
    extraDistance = 0
    if (self.el.extra != undefined) {
      extraHeight = self.el.extra.outerHeight(false)
      extraDistance = 200
    }
    let transformMax = -(footerHeight + extraHeight + extraDistance) + 1
    if (self.st.footer_transform > shadowDistance) {
      self.st.footer_transform = shadowDistance
    } else if (self.st.footer_transform < transformMax) {
      self.st.footer_transform = transformMax
    }
    if (scroller == undefined) {
      scroller = self.st.last_scroller
    }
    if (self.st.footer_transform < shadowDistance && self.st.footer_transform >= transformMax) {
      if (!self.st.covered_scrolled && scroller != undefined) {
        self.st.covered_scrolled = scroller.scrollTop()
        self.addModifier('covered')
        if (scroller.parents('.panel__overlay').length) {
          let $sections, $card, offsetX, offsetY
          let marginTop = parseFloat(scroller.find('.panel__overlay__card').css('margin-top')),
          paddingBottom = parseFloat(scroller.find('.panel__overlay__card').css('padding-bottom'))
          $sections = scroller.find('.article__content')
          $card = scroller.find('.article__container')
          offsetX = 0
          offsetX -= Math.floor(parseFloat($sections.find('.col').first().css('padding-left')))
          offsetX += Math.floor(parseFloat($sections.find('.project').first().css('padding-left')))
          offsetY = paddingBottom * 2 + marginTop
          let rect = $sections.get(0).getBoundingClientRect(),
          properties = {
            'width': $sections.outerWidth(false) + 'px',
            'height': $sections.outerHeight(false) + 'px',
            'position': 'fixed',
            'bottom': $.mlmi.mobile.matchesMedia() ? '20px' : ($(window).height() - rect.bottom + offsetY) + 'px',
            'left': $.mlmi.mobile.matchesMedia() ? 0 : (rect.left + offsetX) + 'px',
            'pointer-events': 'none',
            'z-index': 2,
          }
          $card.css({
            'width': $card.outerWidth(false) + 'px',
            'height': $card.outerHeight(false) + 'px',
          })
          $sections.css(properties)
        } else {
          for (let panelName in self.panels) {
            let panel = self.panels[panelName],
            panel_scroller = panel.el.scroller.el.scroller
            panel.third_scroll = panel_scroller.scrollTop()
            let $sections, $card, offsetX, offsetY
            $sections = panel_scroller.find('.panel__sections-container')
            $card = panel_scroller.find('.panel__content-card')
            let marginTop = parseFloat($card.css('margin-top'))
            offsetX = 0
            offsetY = 15
            let rect = $sections.get(0).getBoundingClientRect(),
            properties = {
              'width': $sections.outerWidth(false) + 'px',
              'height': $sections.outerHeight(false) + 'px',
              'position': 'fixed',
              'bottom': $.mlmi.mobile.matchesMedia() ? '20px' : ($(window).height() - rect.bottom + offsetY) + 'px',
              'left': $.mlmi.mobile.matchesMedia() ? 0 : (rect.left + offsetX) + 'px',
              'pointer-events': 'none',
              'z-index': 2,
            }
            $card.css({
              'width': $card.outerWidth(false) + 'px',
              'height': $card.outerHeight(false) + 'px',
            })
            $sections.css(properties)
          }
        }
      } else if (self.st.covered_scrolled) {
        if (scroller.parents('.panel__overlay').length) {
          scroller.scrollTop(self.st.covered_scrolled)
        } else {
          for (let panelName in self.panels) {
            let panel = self.panels[panelName]
            panel.el.scroller.el.scroller.scrollTop(panel.third_scroll)
          }
        }
      }
    } else {
      if ((e == 'reset' || self.st.covered_scrolled) && scroller != undefined) {
        if (scroller.parents('.panel__overlay').length) {
          let $sections = scroller.find('.article__content'),
          $card = scroller.find('.article__container')
          $sections.attr('style', '')
          $card.attr('style', '')
          scroller.scrollTop(self.st.covered_scrolled)
        } else {
          for (let panelName in self.panels) {
            let panel = self.panels[panelName],
            panel_scroller = panel.el.scroller.el.scroller,
            $sections = panel_scroller.find('.panel__sections-container'),
            $card = panel_scroller.find('.panel__content-card')
            $sections.attr('style', '')
            $card.attr('style', '')
            if (self.hasClass('panels--third') && e != 'reset') {
              panel_scroller.scrollTop(panel.third_scroll)
            }
            panel.third_scroll = 0
          }
        }
        self.removeModifier('covered')
        self.st.covered_scrolled = false
        self.removeModifier('hover-portfolio hover-atelier hover-panorama')
        if (self.hasClass('panels--third') && self.st.last_hovered != undefined) {
          self.addModifier('hover-' + self.st.last_hovered.name)
        }
        self.st.last_hovered = undefined
      }
    }

    /* extra transform */
    let currentTransform = self.st.footer_transform,
    extraTransform = currentTransform
    if (extraTransform < -extraHeight) {
      extraTransform = -extraHeight
    }
    if (self.el.extra != undefined) {
      self.el.extra.css({
        transform: 'translateY(' + extraTransform + 'px)',
      })
    }
    currentTransform -= extraTransform - shadowDistance - extraDistance
    self.el.footer.removeClass('footer--leaving').css({
      transform: 'translateY(' + currentTransform + 'px)',
    })
  }

  self.set_footer = function(panel) {
    if ($.mlmi.isTouch) {
      $('.panel').css('padding-bottom', '')
      $('.panel__content-card').css('padding-bottom', '')
      if (panel) {
        self.append(self.el.footer)
        let footerHeight = self.el.footer.outerHeight(false)
        panel.find('.panel__content-card').append(self.el.footer)
        footerHeight = self.el.footer.outerHeight(false)
        setTimeout(function() {
          footerHeight = self.el.footer.outerHeight(false)
          panel.find('.panel__content-card').css('padding-bottom', footerHeight + 'px')
        }, 200)
      } else {
        self.append(self.el.footer).css('padding-bottom', '')
      }
    } else {
      self.append(self.el.footer).css('padding-bottom', '')
      self.el.footer.off('mousewheel').on('mousewheel', panel.mousewheeled)
    }
  }

  self.dismiss_footer = function() {
    self.BlockElement().removeModifier('covered')
    self.st.covered_scrolled = false
    self.st.footer_transform = 0
    self.el.footer.css('transform', '').addModifier('leaving')
  }

  self.back_to_third = function(e) {
    setTimeout(window.randomizeColors, self.st.current_panel == undefined ? 0 : 325)
    self.reset()
    if ($.mlmi.mobile.matchesMedia()) {
      $('.atelier-toolbar__menu').slideUp('fast')
    }
    if ($.mlmi.isTouch && !$.mlmi.mobile.matchesMedia()) {
      self.set_footer(false)
    }
    if (!self.st.is_popping && 'history' in window) {
      let popState = {
        ama: true,
        isPageTransition: false,
        previousPageURL: window.location.href,
        stepIncrement: self.navigation.getStepIncrement(),
        panel: false,
        overlay: false,
      }
      self.st.last_state = Object.assign({}, self.st.current_state)
      popState.previousState = Object.assign({}, self.st.last_state)
      self.st.current_state = Object.assign({}, popState)
      document.title = self.attr('data-title')
      window.history.pushState(popState, document.title, self.data('home-url'))
    }
    self.st.is_popping = false
    return false
  }

  self.back_to_home = function() {
    let backDelay = 0,
    has_overlay = self.st.current_panel != undefined && self.st.current_panel.overlay != undefined
    if (has_overlay) {
      self.st.current_panel.overlay.close()
      self.dismiss_footer()
      backDelay = 225
    } else if (self.st.covered_scrolled) {
      self.dismiss_footer()
      backDelay = 225
    }
    setTimeout(function() {
      self.move_footer('reset', 8000, undefined)
      setTimeout(function() {
        self.back_to_third()
      }, backDelay)
    }, backDelay)
    return false
  }

	self.initialize_panels = function() {
    self.el.panels.each(function() {
      let panel = $(this).Panel(self)
      if (panel.attr('aria-expanded') == 'true') {
        self.st.current_panel = panel
      }
      self.panels[panel.name] = panel
    })
    $('.footer__brand a').on('click', self.back_to_home)
    $('.panel__logo, .atelier-toolbar__mobile-logo').on('click', self.back_to_home).data('preventTransition', 1)
    $('.panel__lang-switcher').data('preventTransition', 1)
	}

  self.initialize_navigation = function() {
    $('.footer-menu__item--tab-portfolio a').data('target-panel', 'portfolio').data('preventTransition', 1)
    $('.footer-menu__item--tab-panorama a').data('target-panel', 'panorama').data('preventTransition', 1)
    $('.footer-menu__item--tab-atelier a').data('target-panel', 'atelier').data('preventTransition', 1)
    $('.footer-menu__item--lang-switcher a').data('preventTransition', 1)
    self.navigation = new Navigation({
      useTransition: false,
      useHistory: true,
      selectors: {
        pageTarget: false,
      },
      on: {
        linkClicked: self.link_clicked,
        popState: function(href, popState) {
          self.st.is_popping = true
          if (popState.panel) {
            if (popState.overlay) {
              let link = $('<a>').attr({
                'href': href,
                'data-target-panel': popState.panel,
                'data-overlay': true,
                'data-switch': true,
              })
              self.navigation.isPopping = true
              self.navigation.getPage(href)
              self.link_clicked(link)
            } else if ((self.st.current_panel == undefined || self.st.current_panel.name == popState.panel)) {
              self.navigation.abortRequest()
              if (self.st.current_panel != undefined && self.st.current_panel.overlay != undefined) {
                self.st.current_panel.previous_overlay = self.st.current_panel.overlay
                self.st.current_panel.overlay.close()
                self.st.current_panel.overlay = undefined
              }
              self.open(popState.panel, true)
              self.st.is_popping = false
            } else {
              self.navigation.abortRequest()
              self.open(popState.panel, true)
              self.st.is_popping = false
            }
          } else {
            self.navigation.abortRequest()
            self.back_to_home()
          }
          return false
        }
      },
      filter: {
        popState: function(popState, stateFunction) {
          if (stateFunction != 'popState') {
            popState.ama = true
            popState.panel = self.st.current_panel == undefined ? false : self.st.current_panel.name
            popState.overlay = (stateFunction == 'pushState') ? true : ($('.panel__overlay').length ? true : false)
            popState.isPageTransition = false
            if (stateFunction == 'replaceState') {
              popState.previousTitle = $('.single-article__title--glossaire').length ? $('.single-article__title--glossaire').html() : ''
            }
            self.st.last_state = Object.assign({}, self.st.current_state)
            popState.previousState = Object.assign({}, self.st.last_state)
            self.st.current_state = Object.assign({}, popState)
          }
          return popState
        },
      },
    })
    self.find('.maximize-buttons__item').on('click', self.maximize)
    $(window).on('page_load', self.page_loaded)
  }

  self.footer_mousewheeled = function(e, delta) {
    if (self.st.last_scroller != undefined) {
      self.st.last_scroller.parents('.panel').Panel().mousewheeled(e, delta)
    } else if (self.st.current_panel != undefined) {
      self.st.current_panel.mousewheeled(e, delta)
    }
  }

  self.initialize_footer = function() {
    /* mousewheel scroll */
    if (!$.mlmi.isTouch) {
      self.el.footer.off('mousewheel').on('mousewheel', self.footer_mousewheeled)
    }

    /* navigation */
    self.el.footer.find('a').on('click', function() {
      if ($.mlmi.mobile.matchesMedia()) {
        if ($(this).is('.footer-menu__item--parent a')) {
          $(this).parent().toggleClass('footer-menu__item--opened')
          $(this).parent().find('.footer-menu__sub-menu').slideToggle(function() {
            self.set_footer(self.st.current_panel)
          })
          return false
        }
      } else {
        if ($(this).data('target-panel')) {
          self.open($(this).data('target-panel'), true)
          return false
        } else if ($(this).parents('.footer-menu__item--parent').length) {
          let href = $(this).attr('href'), hash = undefined
          if (href.indexOf("#")) {
            hash = href.substr(href.indexOf("#"))
          }
          let target_panel = $(this).parents('.footer-menu__item--parent').find('.footer-menu__link').data('target-panel')
          self.open(target_panel, true, hash)
        }
      }
    })

    /* set footer on load */
    if (self.st.current_panel != undefined) {
      self.set_footer(self.st.current_panel)
    }
  }

	return function() {
    self.BlockElement()
    self.initialize_panels()
    self.initialize_navigation()
    self.initialize_footer()
    self.data('panels', self)
	  return self
	}()
}

export default {
	init() {
    return $('.panels').Panels()
	},
}
